import styled from 'styled-components';
import {typographyStyles} from '../../../../utils/styles';

const StyledBalancePageHeaderVisibility = styled.div`
  display: ${props => props.$visible ? 'block' : 'none'};
`;

const StyledBalanceDetailsWarning = styled.div`
  ${typographyStyles.body.regular};
  color: ${props => props.theme.colors.neutral_10};
  
  .ant-space-item {
    display: flex;
    
    & > svg {
      path {
        fill: ${props => props.theme.colors.functional_warning};
      }
    }
  }
`;

export {
  StyledBalanceDetailsWarning,
  StyledBalancePageHeaderVisibility
};
